import { googleLogout } from "@react-oauth/google"
import { useAppDispatch } from "@redux/app/hooks"
import { APP_STRUCTURE_QUERY_KEY } from "@redux/features/appStructure/queries"
import { setUserData } from "@redux/features/userData/userDataSlice"
import { useQueryClient } from "@tanstack/react-query"
import { useNavigate } from "@tanstack/react-router"
import { requestApi2 } from "@utils/http"
import { authEndpoints } from "api"
import { useTranslation } from "react-i18next"

export default function LogoutGoogle() {
	const { t } = useTranslation()
	const dispatch = useAppDispatch()
	const navigate = useNavigate()
	const queryClient = useQueryClient()

	const logOut = async () => {
		console.log("trying to logout from google...")
		try {
			googleLogout()
			await requestApi2(authEndpoints.logOut)
			dispatch(
				setUserData({
					name: "unknown",
					email: "unknown",
					isAuthenticated: false,
					profilePicture: "",
				})
			)
			queryClient.removeQueries({
				queryKey: APP_STRUCTURE_QUERY_KEY,
				exact: true,
			})
			navigate({ to: "/" })
			console.log("Logout made successfully")
		} catch (error) {
			console.log("Logout failed")
			console.log("error: ", error)
		}
	}

	return (
		<button
			className="text-menu"
			onClick={() => logOut()}
		>
			{t("LOG OUT")}
		</button>
	)
}
